import PropTypes from 'prop-types'
import React from 'react'

import HeaderContainerGrid from '@/components/headerContainer/Grid'

import { HeaderActions, HeaderSeparator, ReportDatePicker, RunButton } from '@/components/reports/header';

const propTypes = {
  onChangeDates: PropTypes.func,
  dates: PropTypes.object,
  sync: PropTypes.func,
  isLoading: PropTypes.bool,
}

const ReportsProgressionHeader = ({ onChangeDates, dates, sync, isLoading, children }) => <HeaderContainerGrid title='Path Finder Report'>
  <HeaderActions>
    <ReportDatePicker dates={dates} onChange={onChangeDates} />
    <HeaderSeparator />
    {children}
    <RunButton isLoading={isLoading} disabled={isLoading} onClick={sync} />
  </HeaderActions>
</HeaderContainerGrid>

ReportsProgressionHeader.propTypes = propTypes

export default ReportsProgressionHeader
